import React, { Component } from 'react';
import moment from 'moment-jalaali';
import { requestState } from "../../constants/enum.constants";
import BSelectInput from "../../helpers/bselect-input";
import Select from 'react-select';
import CertRequestServiceModel from "../../models/certrequestservice";
import { dateDataFormatter,enumDataFormatter,nestadDataFormatter,rightAlignStyle } from "../../helpers/table-formatter";

import { BootstrapTable , TableHeaderColumn  } from 'react-bootstrap-table';


function buttonFormatter(cell, row,extra) {
    return (
      <div>
        <button className="btn btn-default btn-md" onClick={()=> extra.deleteServiceHandler(cell)}>حذف</button>
          
      </div>
    );
}


class CertReqServicePartial extends Component {
    constructor(props) {
        super(props);
        this.state = {  
            certTypeGroupList:null,
            CertificationTypeGroupId:null,
            certTypeList:null,
            selectedcertTypeList:null,
            _CertificationTypeId:null,
            _model:new CertRequestServiceModel(this.refs)
        }
        this.updateCertTypeGroupSelect=this.updateCertTypeGroupSelect.bind(this);
        this.updateCertTypeSelect=this.updateCertTypeSelect.bind(this);
        this.refreshModel=this.refreshModel.bind(this);
        this.getData=this.getData.bind(this);
        this.handleAddServiceClick=this.handleAddServiceClick.bind(this);
      
    }

    componentWillReceiveProps(newProps)
    {
        const {certTypeGroupList,certTypeList,model}=newProps;
         
        if(certTypeGroupList && this.state.certTypeGroupList ==null)
        {
            this.setState({

                certTypeGroupList:certTypeGroupList,    
            });
        }
        if(certTypeList && this.state.certTypeList ==null)
        {
            this.setState({

                certTypeList:certTypeList.filter(x=>x.boolvalue2==true),    
            });
        }
        if(model)
        {
            this.setState({
                CertificationTypeGroupId: this.state.certTypeGroupList && this.state.certTypeGroupList.find(p=>p.value===model.CertificationTypeGroupId)
            })
        }
       // this.forceUpdate();
       
      
    }
    updateCertTypeGroupSelect(item) {
        this.setState({
            CertificationTypeGroupId:item && this.state.certTypeGroupList && this.state.certTypeGroupList.find(p=>p.value===item.value),
            selectedcertTypeList:this.state.CertificationTypeGroupId && this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value):[],
            //CertificationTypeId:this.state.CertificationTypeGroupId && this.state.certTypeList!=null ? this.state.certTypeList.filter(p=>p.parentId===item.value)[0]:[]
        });
       // console.log('ss',this.state.selectedcertTypeList)
       
       
       
    }

    updateCertTypeSelect(item) {

        console.log("*****ITEM",item)
        this.setState({
            _CertificationTypeId:item && this.state.certTypeList && this.state.certTypeList.find(p=>p.value===item.value),
           
        });

        console.log("******CertificationTypeId",this.state._CertificationTypeId)

       // this.refreshModel();
      //  console.log('CertificationTypeId',this.state._CertificationTypeId)
      
    }

    refreshModel () {
        let __model = new CertRequestServiceModel(this.refs);  

        console.log('refs',this.refs);
        this.setState({

            _model:__model

        });

        console.log('***MODEL',__model);    
    }
    getData() {
        let model = new CertRequestServiceModel(this.refs);
        return model;
    }
    handleAddServiceClick = (e) => {

        let model = new CertRequestServiceModel(this.refs);
        console.log("MODEL",model);
        this.props.btnAddServiceHandler(e);
        // if (this.validator.allValid()) {
            
        //     this.props.submitHandler(e);

        // } else {
        //     this.validator.showMessages();
           
        //     this.forceUpdate();
        // }
    };
   
   
  
    render() { 


        const {model} = this.props;
        const {_model} = this.state;
        const {certTypeGroupList,certTypeList,CertificationTypeGroupId,selectedcertTypeList,_CertificationTypeId}= this.state;
        console.log('_CertificationTypeId',_CertificationTypeId)    

        console.log('_MODEL',model) 
        return (  

            <div>

                <div className="row">
                    <div className="col-md-5">  

                        <input type="hidden"  value={model && model.Id} name="CertificationRequestId" ref="CertificationRequestId"></input>
                        <input type="hidden"  value={_CertificationTypeId && _CertificationTypeId.value} name="CertificationTypeId" ref="CertificationTypeId"></input>
                        
                        <div class="form-group">
                            <label class="control-label" for="email">گروه گواهی</label>
                            
                            
                                { certTypeGroupList &&

                                    <BSelectInput 
                                        
                                    // onChange={this.refreshModel}
                                       value ={this.state.CertificationTypGroupId && this.state.CertificationTypGroupId.value }                                   
                                        options={certTypeGroupList && certTypeGroupList.constructor === Array ? certTypeGroupList : []}
                                        onChangeHandler={this.updateCertTypeGroupSelect}
                                        clearable={false}
                                        normal={true}
                                        name="CertificationTypeGroupId"
                                        
                                    />
                                }
                           
                        </div>

                    </div>
                    <div className="col-md-5">
                        <div class="form-group">
                            <label class="control-label" for="email">نوع گواهی</label>
                            
                            
                               
                                    <Select 
                                       
                                        onChange={this.updateCertTypeSelect}
                                        value ={_CertificationTypeId }                                   
                                        options={selectedcertTypeList && selectedcertTypeList.constructor === Array ? selectedcertTypeList : []}
                                        
                                        clearable={true}
                                        placeholder="انتخاب کنید"
                                        noResultsText="نتیجه‌ای یافت نشد"
                                        name="CertificationTypeId"
                                      
                                        
                                    />


                               
                           
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div class="form-group" style={{marginTop:25}}>
                       
                            <button type="button" className="btn btn-default btn-md" onClick={this.handleAddServiceClick}> افزودن</button>
                        </div>
                            
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                    <BootstrapTable data={model && model.CertificationRequestServices}  striped hover
                        headerContainerClass='rightAlignStyle'
                        remote={ true }
                        bodyContainerClass='rightAlignStyle'>
                        
                        <TableHeaderColumn  isKey dataField='Id' hidden >id</TableHeaderColumn>
                        <TableHeaderColumn dataField='CertificationType' formatExtraData="Title" thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ nestadDataFormatter }  >عنوان</TableHeaderColumn>
                      
                        <TableHeaderColumn dataField='Id' thStyle={{textAlign:"right"}} tdStyle={{textAlign:"right"}} dataFormat={ buttonFormatter } formatExtraData={ this.props}></TableHeaderColumn>
                         
                    </BootstrapTable>
                    </div>           
                </div>

            </div>
  
        );
    }
}
 
export default CertReqServicePartial;